import styled from 'styled-components';

export const StyledDiv = styled.div`
  padding: 0px 48px;
`;

export const StyledProgressBar = styled.div`
  padding-top: 40px;
  padding-right: 20px;
`;
